const NS = 'StaffCtrl';

export default function StaffCtrl() {
  "ngInject";

  const vm = this;
  //-- define public properties
  vm.title = 'Staff';
  //-- define public methods
}
